import React, { useEffect, useState } from 'react'
import { useSubmitControler } from '../../loginController'
import logoSB from '../../../../../../assets/img/logo-colores-originales-sin-bajada.png'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import './loginForm.css'
import logger from '../../../../../../utils/logger'
import { useRedirect } from '../../../../../../hooks/useRedirect'
import { useToast } from '../../../../../../hooks/useToast'
import { ToastContainer } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import { resetLogoutContext } from '../../../../../../redux/slices/routing'


export const UserLoginForm = () => {

    const { showToast } = useToast()
const dispatch = useDispatch()

    useEffect(() => {
        document.title = 'TPA® Oficial - Iniciar sesión'
    }, [])

    const { handleSubmit, register, onSubmit, errors, message, response, setMessage, setResponse } = useSubmitControler()


    logger.debug('login response: ', response)
    logger.debug('login message: ', message)

    const [showPassword, setShowPassword] = useState(true)
    const [showModalRecovery, setshowModalRecovery] = useState(false);
    const [showModalUnlockUser, setshowModalUnlockUser] = useState(false);

    const { redirectTo } = useRedirect()

    const location = useLocation()

    logger.debug('location state from: ', location.state?.from)

    // const from = location.state?.from?.pathname || '/Member'
    //  const from = location.state?.from?.pathname 

    //     useEffect(() => {
    //         if (response?.accessToken) {
    //             redirectTo(from)
    //         }
    //     }, [response])

    const navigate = useNavigate()
    const authStatus = useSelector(
        (state) => state.enableRoute.status
    )
    const from = location.state?.from



    const routeAuthorization = () => {

        const menuOption = JSON.parse(localStorage.getItem('menuOption')) || []
        const pathname = from.replace(/^\/+/, '')

        if (pathname.startsWith('FormationInfo')) {
            return { url: pathname }
        }


        const matchedOption = menuOption.find(item => item.url === pathname)

        //? 👉 Retorna el objeto encontrado el primero de la lista 
        return matchedOption || menuOption[0]
    }

    logger.debug('routeAuthorization: ', routeAuthorization())

    const target = routeAuthorization();
    const destination = target?.url && `/${target.url}`;

    logger.debug('destination: ', destination)



    useEffect(() => {
        if (authStatus === 'authorized') {
            // navigate(destination, { replace: true })
            dispatch(resetLogoutContext())
             navigate(destination, { replace: true, state: {} })
            
        }
    }, [authStatus])


    //? Toast para la respuesta del login

    useEffect(() => {
        if (message && response) {
            //console.log('RESULT ES: ', response, message)
            showToast(response, message)
            setMessage('')
            // setResponse(null)

        }
    }, [message, response])



    //?👉 Función para cambiar el estado del modal
    const toggleModal = () => {
        setshowModalRecovery(!showModalRecovery);
    }


    const toggleUnlockUser = () => {
        setshowModalUnlockUser(!showModalUnlockUser);
    }


    //?👉 Función mostrar la contraseña
    const togleEye = () => {
        setShowPassword(!showPassword)
    }


    return (
        <div className="form-container">

            <ToastContainer
            />
            <form className="form-login" onSubmit={handleSubmit(onSubmit)}>

                <div className="logo-login">
                    <img src={logoSB} alt="logo" />
                </div>

                <h1 className="title title-login ">ADMIN</h1>

                <div className="form-floating mb-3">
                    <input
                        {...register('username', { required: 'Usuario' })}
                        type="text"
                        name={'username'}
                        className={`form-control ${errors.username || response === 401 ? 'inError' : ''}`}
                        id="floatingInput"
                        autoFocus autoComplete='userName'
                        placeholder="Usuario"
                    />
                    <label htmlFor="floatingInput">Usuario</label>
                </div>




                <div className="input-group">


                    <div className="form-floating flex-grow-1">

                        <input
                            {...register('password', { required: 'password is required', })}
                            type={showPassword ? "password" : "text"}
                            className={`form-control ${errors.password || response === 401 ? 'inError' : ''}`}
                            name={'password'}
                            id="floatingPassword"
                            placeholder="Contraseña"
                            autoComplete="current-password"
                        />
                        <label htmlFor="floatingPassword">Contraseña</label>

                        <span className="span-eye toggle-password" ><i onClick={() => togleEye()} className={showPassword ? "bi bi-eye-slash bi-class-eye" : "bi bi-eye bi-class-eye"}></i></span>

                    </div>


                </div>

                {response === 401 &&
                    <div id="errorMessage" class="error-message">Por favor revise su usuario y/o contraseña e intente nuevamente</div>

                }



                <input type="submit" className="button" value="Acceder" />

            </form>



        </div>
    )
}

